import React, { useState, useEffect } from 'react';
import { 
  BrowserRouter as Router, 
  Route, 
  Switch,
  useLocation,
  Redirect
} from 'react-router-dom';
import './App.css';
import './components/common/button-hover-styles.css';

// 导入页面组件
import Home from './components/Home/Home';
import Login from './components/Auth/Login';
import Create from './components/Create/Create';
import Detail from './components/Detail/Detail';
import Search from './components/Search/Search';
import Profile from './components/Profile/Profile';
import About from './components/Pages/About/About';
import Forum from './pages/Forum/Forum.jsx';
import UserAgreement from './pages/UserAgreement';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Messages from './components/Messages/Messages';
import Subscription from './components/Subscription/Subscription';
import Discover from './components/Discover/Discover';

// 导入上下文
import { UserContext } from './context/UserContext';

// 创建滚动控制组件
const ScrollToTop = () => {
  const location = useLocation();
  
  useEffect(() => {
    // 添加多种方法强制滚动
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    
    // 使用 setTimeout 确保滚动发生在渲染后
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
    
    return () => clearTimeout(timeoutId);
  }, [location]);
  
  return null;
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 从本地存储加载用户信息
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    // 立即结束加载
    setLoading(false);
  }, []);

  // 用户登录处理
  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  // 用户登出处理
  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  if (loading) {
    return (
      <div className="elegant-app">
        <div className="elegant-loading-screen-orange">
          <div className="elegant-loading-indicator">
            <div className="elegant-loading-spinner-white"></div>
            <div className="elegant-loading-spinner-inner-white"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <UserContext.Provider value={{ user, handleLogin, handleLogout }}>
      <Router>
        <ScrollToTop />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/login" component={Login} />
          <Route path="/create" component={Create} />
          <Route path="/puzzle/:id" component={Detail} />
          <Route path="/search" component={Search} />
          <Route path="/profile/:id" component={Profile} />
          <Route path="/about" component={About} />
          <Route path="/forum" component={Forum} />
          <Route path="/agreement" component={UserAgreement} />
          <Route path="/privacy" component={PrivacyPolicy} />
          <Route path="/messages" component={Messages} />
          <Route path="/subscription" component={Subscription} />
          <Route path="/discover" component={Discover} />
          <Route path="/notifications">
            <Redirect to="/messages" />
          </Route>
        </Switch>
      </Router>
    </UserContext.Provider>
  );
}

export default App;